import { graphql } from '../gql';

export const getReportDetails = graphql(`
  query GetReportDetails($reportName: String!) {
    getReportsConfigurations(input: { application: FOODA_FOR_RESTAURANTS, menuTitles: [$reportName] }) {
      error {
        code
        message
      }
      reportsConfigurations {
        headline
        subtitle
        tableauDesktopUrl
        tableauMobileUrl
        terms {
          description
          term
        }
      }
    }
  }
`);
